export class Search {
  activiteIds?: Array<string> | null;
  term?: string | null;
  search?: string | null;
  action?: string | null;
  limit?: number | null;
  type?: string | null;
  offset?: number | null;
  typeActivite?: string | null;
  order?: string | null;
  orderBy?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  dateDebut?: string | null;
  dateFin?: string | null;
  familleIds?: Array<string> | null;
  departementIds?: Array<string> | null;
  statutAdministratif?: string | null;
  statutAdministratifInclus?: Array<string> | null;
  statutAdministratifExclus?: Array<string> | null;
  statutLivraison?: string | null;
  numeroCommande?: string | null;
  withNoStock?: any | null;
  withClosed?: number | null;
  withReservationsOnly?: number | null;
  activite?: string | null;
  familleProduit?: string | null;
  fournisseur?: string | null;
  beneficiaire?: string | null;
  moyenPaiement?: string | null;
  themes?: Array<string> | null;
  favoris?: number | null;
  home?: number | null;
  clos?: number | null;
  expired?: number | null;
  enveloppe?: number | null;
  ayantDroit?: number | null;
  latitude?: number | null;
  longitude?: number | null;
  top?: string | null;
  withReglements?: number | null;

  constructor(
    {
      activiteIds = null,
      term = null,
      search = null,
      action = null,
      limit = null,
      type = null,
      offset = null,
      typeActivite = null,
      order = null,
      orderBy = null,
      startDate = null,
      endDate = null,
      dateDebut = null,
      dateFin = null,
      familleIds = null,
      departementIds = null,
      statutAdministratif = null,
      statutAdministratifInclus = null,
      statutAdministratifExclus = null,
      statutLivraison = null,
      numeroCommande = null,
      withNoStock = null,
      withClosed = null,
      withReservationsOnly = null,
      activite = null,
      familleProduit = null,
      fournisseur = null,
      beneficiaire = null,
      moyenPaiement = null,
      themes = null,
      favoris = null,
      home = null,
      clos = null,
      expired = null,
      enveloppe = null,
      ayantDroit = null,
      latitude = null,
      longitude = null,
      top = null,
      withReglements = null,
    }: Search
  ) {
    this.activiteIds = activiteIds;
    this.term = term;
    this.search = search;
    this.action = action;
    this.type = type;
    this.limit = limit;
    this.offset = offset;
    this.typeActivite = typeActivite;
    this.order = order;
    this.orderBy = orderBy;
    this.startDate = startDate;
    this.endDate = endDate;
    this.dateDebut = dateDebut;
    this.dateFin = dateFin;
    this.familleIds = familleIds;
    this.departementIds = departementIds;
    this.statutAdministratif = statutAdministratif;
    this.statutAdministratifInclus = statutAdministratifInclus;
    this.statutAdministratifExclus = statutAdministratifExclus;
    this.statutLivraison = statutLivraison;
    this.numeroCommande = numeroCommande;
    this.withNoStock = withNoStock;
    this.withClosed = withClosed;
    this.withReservationsOnly = withReservationsOnly;
    this.activite = activite;
    this.familleProduit = familleProduit;
    this.fournisseur = fournisseur;
    this.beneficiaire = beneficiaire;
    this.moyenPaiement = moyenPaiement;
    this.themes = themes;
    this.favoris = favoris;
    this.home = home;
    this.clos = clos;
    this.expired = expired;
    this.enveloppe = enveloppe;
    this.ayantDroit = ayantDroit;
    this.latitude = latitude;
    this.longitude = longitude;
    this.top = top;
    this.withReglements = withReglements;
  }
}



// WEBPACK FOOTER //
// ./src/shared/models/search/search.model.ts